import { AuditSnapshotRow } from './auditMetrics'

const propertyBase = {
    total_apartments: 557,
    avg_health_score: 84.2,
    health_critical: 28,
    health_poor: 41,
    health_fair: 96,
    health_good: 214,
    health_excellent: 178,
    properties_with_0_vendors: 12,
    properties_with_0_damage_types: 8,
    total_damages_last_30d: 142,
    properties_with_damages_last_30d: 89,
    properties_that_havent_synced_leases: 23,
    properties_with_no_active_schedule: 41,
    total_move_out_inspections: 318,
    total_complete_inspection_units: 2104,
    total_scheduled_inspection_units: 2890,
    total_active_schedules: 412,
    active_schedule_pct: 92.6,
    total_scheduled_workorders: 18420,
    total_monthly_requests: 956,
}

const projectBase = {
    total_projects: 1005,
    total_workorders: 48210,
    total_behind: 3210,
    behind_pct: 6.7,
    not_started: 8120,
    in_progress: 12450,
    complete: 15200,
    approved: 8900,
    invoiced: 3540,
    cai: 27640,
    cai_pct: 57.3,
    units_ready_pct: 67.4,
    cost_per_unit: 1840,
    cost_per_bed: 620,
    total_budget: 19200000,
    total_forecasted: 18500000,
    budget_variance: 700000,
    avg_forecasted_per_project: 18408,
}

const scaleMetrics = (
    base: Record<string, number>,
    factor: number,
): Record<string, number> => {
    const out: Record<string, number> = {}
    for (const [key, value] of Object.entries(base)) {
        if (key.endsWith('_pct') || key === 'avg_health_score') {
            out[key] = Math.round(value * (0.97 + factor * 0.03) * 10) / 10
        } else if (
            key.startsWith('cost_') ||
            key.includes('forecasted') ||
            key.includes('avg_')
        ) {
            out[key] = Math.round(value * factor)
        } else {
            out[key] = Math.round(value * factor)
        }
    }
    return out
}

export const MOCK_PROPERTY_SNAPSHOTS: AuditSnapshotRow[] = [
    {
        id: 'prop-mock-1',
        label: 'Jun 24, 2026',
        created_at: '2026-06-24T12:00:00Z',
        is_scheduled: true,
        xlsx_url: null,
        metrics: scaleMetrics(propertyBase, 1.0),
    },
    {
        id: 'prop-mock-2',
        label: 'Jun 17, 2026',
        created_at: '2026-06-17T12:00:00Z',
        is_scheduled: true,
        xlsx_url: null,
        metrics: scaleMetrics(propertyBase, 0.98),
    },
    {
        id: 'prop-mock-3',
        label: 'Jun 10, 2026',
        created_at: '2026-06-10T12:00:00Z',
        is_scheduled: true,
        xlsx_url: null,
        metrics: scaleMetrics(propertyBase, 0.95),
    },
    {
        id: 'prop-mock-4',
        label: 'Jun 3, 2026',
        created_at: '2026-06-03T12:00:00Z',
        is_scheduled: true,
        xlsx_url: null,
        metrics: scaleMetrics(propertyBase, 0.93),
    },
    {
        id: 'prop-mock-5',
        label: 'May 27, 2026',
        created_at: '2026-05-27T15:30:00Z',
        is_scheduled: false,
        xlsx_url: null,
        metrics: scaleMetrics(propertyBase, 0.91),
    },
]

export const MOCK_PROJECT_SNAPSHOTS: AuditSnapshotRow[] = [
    {
        id: 'proj-mock-1',
        label: 'Jun 24, 2026',
        created_at: '2026-06-24T12:00:00Z',
        is_scheduled: true,
        xlsx_url: null,
        metrics: scaleMetrics(projectBase, 1.0),
    },
    {
        id: 'proj-mock-2',
        label: 'Jun 17, 2026',
        created_at: '2026-06-17T12:00:00Z',
        is_scheduled: true,
        xlsx_url: null,
        metrics: scaleMetrics(projectBase, 0.97),
    },
    {
        id: 'proj-mock-3',
        label: 'Jun 10, 2026',
        created_at: '2026-06-10T12:00:00Z',
        is_scheduled: true,
        xlsx_url: null,
        metrics: scaleMetrics(projectBase, 0.94),
    },
    {
        id: 'proj-mock-4',
        label: 'Jun 3, 2026',
        created_at: '2026-06-03T12:00:00Z',
        is_scheduled: true,
        xlsx_url: null,
        metrics: scaleMetrics(projectBase, 0.9),
    },
    {
        id: 'proj-mock-5',
        label: 'May 27, 2026',
        created_at: '2026-05-27T16:00:00Z',
        is_scheduled: false,
        xlsx_url: null,
        metrics: scaleMetrics(projectBase, 0.72),
    },
]
